import { useLocation, Link } from "react-router-dom";
import { getPrevNext } from "../../utils/tocHelpers";
import "./ChapterNav.css";

export function ChapterNav() {
  const location = useLocation();
  const { prev, next } = getPrevNext(location.pathname);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className={`chapter-nav ${!prev && next ? 'single-next' : ''}`}>
      {prev && <Link to={prev.path}>← {prev.title}</Link>}
      {next && <Link to={next.path} style={{ float: "right" }}>{next.title} →</Link>}
    </div>
  );
}